import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { logsList_template } from "../components/templates/logsList_template";
import { header } from "./header";
import { hideLoadingOverlay, showLoadingOverlay } from "~/utils/listLoading";
export class logs extends vnModule_knockoutJS {
    getModuleName() {
        return "logs";
    }
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle("Logs");
        this.elementsList = new logsList_template("logs", this.viewModel, this);
        return [this.elementsList.build()];
    }
    fillPage() {
        this.getListFormData();
    }
    getListResultsElement() {
        return this.elementsList?.builtTemplate?.querySelector?.("#list-results") ?? null;
    }
    reorderLogs() {
        this.getListData();
    }
    getListFormData() {
        const listResults = this.getListResultsElement();
        if (listResults) {
            showLoadingOverlay(listResults, "Loading logs...");
        }
        const params = [];
        params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler("/api/logs/list_from_data/", params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }
    onFilterRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();
            });
        };
    }
    getListData() {
        const listResults = this.getListResultsElement();
        if (listResults) {
            showLoadingOverlay(listResults, "Loading logs...");
        }
        if ("getListData" in this.XHRHdl) {
            this.XHRHdl["getListData"].cancelAndReset();
        }
        const subViewModel = this.elementsList.getViewModelForRequest();
        const usrReq_params = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl["getListData"] = new XMLHttpRequestHandler("/api/logs/get/", usrReq_params, this);
        this.XHRHdl["getListData"].onReadyStateFunction = this.onDataRequestReturn;
        this.XHRHdl["getListData"].execute();
    }
    onDataRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            const listResults = obj.getListResultsElement();
            if (listResults) {
                hideLoadingOverlay(listResults);
            }
        };
    }
    updateList(responseParsed) {
        this.elementsList.setPageNumber(responseParsed.currentPage);
        this.elementsList.setPagination(responseParsed.totalCount);
        this.elementsList.setResultPage(responseParsed.totalCount);
        this.elementsList.setLogs(responseParsed.data);
        this.elementsList.resetTrackedLogId();
    }
    resetPageNumber() {
        this.elementsList.resetPageNumber();
    }
    resetOrderParameters() {
        this.elementsList.resetOrderParameters();
    }
    updateFilters(responseParsed) {
        this.elementsList.setAccountFilterItems(responseParsed["executors"]);
        const operationsList = this.prepareOperationsList(responseParsed["operations"]);
        this.elementsList.setOperationFilterItems(operationsList);
    }
    prepareOperationsList(operations) {
        operations.forEach(function (operation, i) {
            operations[i]["id"] = operation["name"];
            operations[i]["name"] = operation["name"].replace(/_/g, " ");
        });
        return operations;
    }
    filterOnChange() {
        this.resetPageNumber();
        this.resetOrderParameters();
        this.resetTrackedLogId();
        this.getListData();
    }
    filterSingleGroupSelectorOnChange() {
        this.filterOnChange();
    }
    filterDropdownOnChange() {
        this.filterOnChange();
    }
    resetTrackedLogId() {
        this.elementsList.resetTrackedLogId();
    }
    paginationOnPageClick() {
        this.getListData();
    }
    filterSimpleCancel() {
        this.resetPageNumber();
        this.resetOrderParameters();
        this.getListData();
    }
    filterSimpleOnChange() {
        this.resetPageNumber();
        this.resetOrderParameters();
        this.getListData();
    }
    autoRefresh() {
        this.getListData();
    }
}
